<template>
  <form v-if="production" class="prod-stack" @submit.prevent="onSave">
    <div v-if="production.shoot_at" class="prod-banner prod-banner--ready">
      <span class="material-icons">event</span>
      <span>
        {{ formatDateTime(production.shoot_at) }}
        <span v-if="production.shoot_venue"> · {{ production.shoot_venue }}</span>
      </span>
    </div>
    <div class="move-card prod-panel space-y-5">
      <ProductionSectionHead title="Shoot" subtitle="Call time, venue, and anything the crew needs on the day." />
      <div class="move-field !mb-0">
        <label for="shoot-at">Shoot day</label>
        <input id="shoot-at" v-model="form.shoot_at" type="datetime-local" class="move-input" />
      </div>
      <div class="move-field !mb-0">
        <label for="shoot-venue">Venue</label>
        <input id="shoot-venue" v-model="form.shoot_venue" class="move-input" placeholder="Studio, location…" />
      </div>
      <div class="move-field !mb-0">
        <label for="shoot-notes">Notes</label>
        <textarea id="shoot-notes" v-model="form.shoot_notes" rows="4" class="move-textarea" placeholder="Call sheet, parking, talent arrival…" />
      </div>
      <p v-if="message" class="prod-success">{{ message }}</p>
      <button type="submit" class="move-btn-primary">Save shoot</button>
    </div>
  </form>
</template>

<script setup>
import { inject, reactive, ref, watch } from 'vue'
import ProductionSectionHead from '../../components/production/ProductionSectionHead.vue'
import { formatDateTime, toDatetimeLocal } from '../../utils/productionDates'

const workspace = inject('productionWorkspace')
const production = workspace.production
const message = ref('')
const form = reactive({ shoot_at: '', shoot_venue: '', shoot_notes: '' })

watch(production, (value) => {
  if (!value) return
  form.shoot_at = toDatetimeLocal(value.shoot_at)
  form.shoot_venue = value.shoot_venue || ''
  form.shoot_notes = value.shoot_notes || ''
}, { immediate: true })

async function onSave () {
  await workspace.save({
    shoot_at: form.shoot_at || null,
    shoot_venue: form.shoot_venue || null,
    shoot_notes: form.shoot_notes || null
  })
  message.value = 'Shoot details saved.'
}
</script>
